import React from 'react';
import {Modal, ModalBody, ModalHeader, Button} from 'reactstrap';

import PaginationTable from '../PaginationTable';
import {formatDate, formatFloat, numberPadding } from '../../../utils/formatting';
import Filters from './Filters';

export default class EvaluationsReport extends React.Component {

    constructor(props) {
        super(props);
        this.fetchReports = this._fetchReports.bind(this);
        this.filterChange = this._filterChange.bind(this);
        this.state = {
            filters : {},
            detailReport : null,
        };
    }

    componentWillMount() {
        this.fetchReports();
    }

    _filterChange(data) {
        this.setState({
            filters : data,
        }, this.fetchReports);
    } 

    _fetchReports(page) {
        this.props.fetchReports('communique-evaluations', page, this.state.filters);
    }

    render() {
        const data = this.props.reportsState.communique_evaluations;
        const paginationData = data ? data.data : {};
        return (
            <div>
                <Filters 
                    requestXlsx={this.props.requestXlsx}
                    report="communique-evaluations"
                    territories={this.props.territories}
                    coordinations={this.props.coordinations}
                    users={this.props.users}  
                    onFilterChange={this.filterChange}  
                />
                {
                    (data||{}).fetching ?
                        <div className="container my-2">
                            <i className="fa fa-spinner fa-spin"></i> Cargando
                        </div>
                    :
                        <PaginationTable {...paginationData} 
                        territories={this.props.territories}
                        coordinations={this.props.coordinations}
                        pageChange={this.fetchReports}
                        showDetail={(report) => this.setState({detailReport : report})}
                        headerComponent={renderHeader}
                        rowComponent={renderRow}/>
                }
                <EvaluationDetail report={this.state.detailReport} toggle={() => this.setState({detailReport : null})}/>
            </div>
        );
    }
}

function renderHeader(props) {
    return (
        <tr>
            <th>
                Territorio
            </th>
            <th>
                Coordinación
            </th>   
            <th>
                No. ejecutivo
            </th>
            <th>
                Nombre ejecutivo
            </th>
            <th>
                Calificación
            </th>
            <th>
                Fecha de evaluación
            </th>
            <th></th>
        </tr>
    );
} 

function renderRow(props) {
    const report = props.item;
    const territory = props.territories.data[report.user.territory_id];
    const coordination = props.coordinations.data[report.user.coordination_id];
    const {showDetail} = props;
    return (
        <tr>
            <td>
                {territory ? territory.name : 'Desconocido'}
            </td>
            <td>
                {coordination ? coordination.name : 'Desconocida'}
            </td>
            <td>
                {numberPadding(report.user.emp_number, 6)}
            </td>
            <td>
                {report.user.name}
            </td>
            <td className={report.grade < 6 ? 'text-danger' : 'text-success'}>
                { formatFloat(report.grade) }
            </td>
            <td>
                {formatDate(report.created_at)}
            </td>
            <td>
                <Button onClick={() => showDetail(report)} size="sm">Detalle</Button>
            </td>
        </tr>
    );    
}


function EvaluationDetail(props) {
    const {report} = props;
    return (
        <Modal isOpen={props.report !== null} toggle={props.toggle} size="lg">
            <ModalHeader toggle={props.toggle}>
                {
                    report ?
                        report.user.name
                    : null
                }
            </ModalHeader>
            <ModalBody>
                <div className="text-right">
                    {
                        report ?
                            <span>
                                {report.communique_evaluation_set.communique_evaluation.communique.name}
                                <br />
                                <small>
                                    Calificación : {formatFloat(report.grade)}
                                </small>
                            </span>
                        : null
                    }
                </div>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>
                                Pregunta
                            </th>
                            <th>
                                Respuesta
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            report ? 
                                report.communique_evaluation_set.communique_answers.map((answer) => {
                                    return (
                                        <tr key={answer.id}>
                                            <td>
                                                {answer.communique_question.question}
                                            </td>
                                            <td>
                                                {
                                                    answer.points <= 0 ?
                                                        <i className="fa fa-times fa-fw"></i>
                                                    :
                                                        <i className="fa fa-fw fa-check"></i>
                                                }
                                                {answer.answer}
                                            </td>
                                        </tr>
                                    );
                                })
                            : null
                        }
                    </tbody>
                </table>
                
            </ModalBody>
        </Modal>
    );
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/reports/EvaluationsReport.jsx
 **/